export const state = () => ({
  orderConfirmSelectedShippingDate: '',
  orderAcceptSelectedStoreName: '',
  orderAcceptOrderManagementId: '',
  orderSelectedOrderAcceptItems: [],
  orderConfirmIntervalId: '',
  selectCategory: {
    itemCategoryId: '#',
    itemCategoryName: '全て'
  },
  stockManagementSelectedMonth: '',
  warehouseStocktakingMonth: '',
  selectedWeekNumber: '',
  salesReportDate: ''
})

export const mutations = {
  CLEAR_ADMIN_SESSION(state) {
    console.log('clear admin session ')
    state.orderConfirmSelectedShippingDate = ''
    state.orderAcceptSelectedStoreName = ''
    state.orderAcceptOrderManagementId = ''
    state.orderSelectedOrderAcceptItems = []
    state.orderConfirmIntervalId = ''
    state.selectCategory = {
      itemCategoryId: '#',
      itemCategoryName: '全て'
    }
    // 店舗在庫棚卸管理の棚卸年月
    state.stockManagementSelectedMonth = ''
    // 倉庫在庫棚卸管理の棚卸年月
    state.warehouseStocktakingMonth = ''
    state.selectedWeekNumber = ''
    state.salesReportDate = ''
  },
  SET_ORDER_CONFIRM_SELECTED_SHIPPING_DATE(state, shippingDate) {
    console.log('mutations set admin shippingDate')
    state.orderConfirmSelectedShippingDate = shippingDate
  },
  SET_ORDER_ACCEPT_SELECTED_STORE_NAME(state, storeName) {
    console.log('mutations set admin storeName')
    state.orderAcceptSelectedStoreName = storeName
  },
  SET_ORDER_ACCEPT_ORDER_MANAGEMENT_ID(state, orderAcceptOrderManagementId) {
    console.log('mutations set orderAcceptOrderManagementId')
    state.orderAcceptOrderManagementId = orderAcceptOrderManagementId
  },
  SET_ORDER_ACCEPT_ITEMS(state, orderSelectedOrderAcceptItems) {
    console.log('mutations set orderSelectedOrderAcceptItems')
    state.orderSelectedOrderAcceptItems = orderSelectedOrderAcceptItems
  },
  SET_ORDER_CONFIRM_INTERVAL_ID(state, orderConfirmIntervalId) {
    console.log('mutations set orderConfirmIntervalId')
    state.orderConfirmIntervalId = orderConfirmIntervalId
  },
  SET_SELECTED_ITEM_CATEGORY(state, selectCategory) {
    console.log('mutations set selectCategory')
    state.selectCategory = selectCategory
  },
  SET_STOCK_MANAGEMENT_SELECTED_MONTH(state, stockManagementSelectedMonth) {
    console.log('mutations set stocktaking month')
    state.stockManagementSelectedMonth = stockManagementSelectedMonth
  },
  SET_WAREHOUSE_STOCKTAING_MONTH(state, warehouseStocktakingMonth) {
    console.log('mutations set warehouse stocktaking month')
    state.warehouseStocktakingMonth = warehouseStocktakingMonth
  },
  SET_SELECTED_WEEK_NUMBER(state, selectedWeekNumber) {
    console.log('mutations set selected week number')
    state.selectedWeekNumber = selectedWeekNumber
  },
  SET_SALES_REPORT_DATE(state, salesReportDate) {
    console.log('mutations set salesReportDate ')
    state.salesReportDate = salesReportDate
  }
}
